import { Component, inject, input, output } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { AuthService } from '../../../core/auth/auth.service';
import { AppIconComponent } from '../app-icon/app-icon.component';
import { NAV_ITEMS } from '../../../core/config/nav.config';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [RouterLink, RouterLinkActive, AppIconComponent],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
})
export class SidebarComponent {
  private readonly authService = inject(AuthService);

  readonly isOpen = input(false);
  readonly closed = output<void>();

  readonly navItems = NAV_ITEMS;

  onNavClick(): void {
    this.closed.emit();
  }

  onSignOut(): void {
    this.authService.logout();
  }
}
